import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { Heading } from '../../heading/heading';
const b = bemClassBuilder('v-showtime-picker-site-details');
export const ShowtimePickerSiteDetails = observer(props => {
    const i18n = useI18n();
    const { site, headingLevel } = props;
    return (_jsx("div", Object.assign({ className: b.block() }, { children: _jsx(Heading, Object.assign({ level: headingLevel, className: b.element('heading', { [headingLevel]: true }) }, { children: i18n.translatable(site.name) })) })));
});
ShowtimePickerSiteDetails.displayName = 'ShowtimePickerSiteDetails';
